// Video macro
$(document).ready(function () {
  // Play video (uploaded to enonic)
  $('.videoWrapper--video .btn--video').click(function () {
    const figure = $(this).parent()
    const container = figure.parent()
    const video = container.children('video')

    video.fadeIn()
    figure.hide()
    video.trigger('play')
  })

  // Play youtube video
  $('.videoWrapper--youtube .btn--video').click(function () {
    const figure = $(this).parent()
    const container = figure.parent()
    const iframeWrapper = container.children('.iframe-wrapper')
    const video = iframeWrapper.children('iframe')
    const videoURL = video.attr('src')

    iframeWrapper.fadeIn()
    figure.hide()
    video.attr('src', video.attr('src') + '?rel=0&modestbranding=1&autoplay=1&mute=1')
  })
})
// End Video macro
